<template>
  <div class="QuotationEditComponent">
    <div v-for="item in items" :key="item.dataIndex" class="row align-items-center mt5 pr5 form-item border-bottom">
      <div :class="['form-item-label' ,'pr5']">
        {{ item.title }}
        <!-- <span :class="['form-item-label-text', item.required ? 'required' : '']">{{ item.title }}</span> -->
      </div>
      <div class="flex-1">
        <template v-if="item.valueType === 'select'">
          <template v-if="isCustom(item)">
            <input v-model="formValues[item.dataIndex]" class="basic-input form-item-input" placeholder="自定义填写"/>
          </template>
          <template v-else>
            <select v-model="formValues[item.dataIndex]" :class="['basic-select','form-item-select', formValues[item.dataIndex] ? '' : 'select-palceholder']" :placeholder="`请选择`">
              <option :value="null">请选择</option>
              <option v-for="option in dictOptions[item.optionKey]" :key="option.value" :value="option.value">{{ option.text }}</option>
              <option v-if="item.dataIndex !== 'unitCode'" value="">自定义填写</option>
            </select>
          </template>
        </template>
        <template v-if="item.valueType === 'textarea'">
          <textarea v-model="formValues[item.dataIndex]" class="basic-textarea form-item-textarea" placeholder="请输入"></textarea>
        </template>
      </div>
      <a v-if="formValues[item.dataIndex] && item.dataIndex !== 'unitCode'" @click="resetFormValue(item.dataIndex)" class="pt3 pb3 pl3 fc-danger">取消</a>
    </div>
    <div :class="`quotation-item ${quoteType == 2 ? 'quotation-section' : ''}`" v-for="(data, dataIndex) in lastData" :key="dataIndex">
      <div v-if="data.section && quoteType == 2" class="quotation-item-title">{{ sectionMapping[data.section] }}</div>
      <QuotationEditTable
        :ref="`QuotationEditTable_${data.section||''}`"
        :quoteType="quoteType"
        :selectUnit="selectUnit"
        :tableData="data"
        :from="from"
        :formValues="formValues"
        :allDicts="allDicts"
        @change="handleChange"
        @cateChange="handleCateChange"
      />
    </div>
    <div v-if="showActionButton" class="row justify-content-around mt10 pl7 pr7">
      <van-button @click="back" type="info" class="btn-common plain" plain>返回</van-button>
      <van-button v-if="formValues.unitCode" @click="publish" type="info" class="btn-common">发布价格</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, quoteDict, quoteLast, quoteTypeLast, getLastMarketPrice,
} from '@/network/NetworkAccessor';
import { QUOTE_TYPE_MAPPING, QUOTE_SECTION, DEFAULT_QUOTE_SECTION } from '@/uitls/const';
import QuotationEditTable from '@/components/QuotationEditTable.vue';

export default Vue.extend({
  name: 'QuotationEditComponent',
  components: {
    QuotationEditTable,
  },
  data() {
    return {
      // 普货、普挑、精挑、挑膏
      sectionMapping: QUOTE_SECTION,
      quoteTypes: [],
      formValues: {
      },
      options: {
        units: [],
        categories: [],
        weight: [],
      },
      quoteValues: {},
      sortQuoteValues: [],
      popupShow: false,
      lastData: [],
      allDicts: {},
    };
  },
  props: {
    quoteType: {
      type: String,
      default: '222',
    },
    from: {
      type: String,
      default: 'quotation', // quotation -报价商报价；market -管理员行情后台报价
    },
    showActionButton: {
      type: Boolean,
      default: false,
    },
    typeId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    quoteTypeConfig() {
      return QUOTE_TYPE_MAPPING[this.quoteType] || {};
    },
    items() {
      const items1 = [
        {
          title: '重量单位',
          dataIndex: 'unitCode',
          valueType: 'select',
          required: true,
          optionKey: 'units',
        },
      ];
      const items2 = [
        {
          title: '价格类型',
          dataIndex: 'priceType',
          valueType: 'select',
          required: true,
          optionKey: 'priceType',
        },
        {
          title: '运费',
          dataIndex: 'info1',
          valueType: 'select',
          required: true,
          optionKey: 'info1',
        },
        {
          title: '死亡',
          dataIndex: 'info2',
          valueType: 'select',
          required: true,
          optionKey: 'info2',
        },
        {
          title: '宣传语',
          dataIndex: 'adSlogan',
          valueType: 'textarea',
        },
      ];
      return this.from === 'market' ? items1 : [...items1, ...items2];
    },
    selectUnit() {
      return (this.options.units && this.options.units.find(item => item.value === this.formValues.unitCode)) || {};
    },
    dictOptions() {
      // 处理规格码表，规格和重量单位有关系
      const weight = (this.selectUnit && this.selectUnit.sub) || [];
      // console.log('----this.selectUnit---', this.selectUnit);
      return {
        ...this.options,
        weight,
      };
    },
  },
  watch: {
    typeId(val) {
      if (val) {
        this.getLastData();
      }
    },
    quoteType: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initValues();
          this.initOptions();
          this.getLastData();
        }
      },
    },
  },
  methods: {
    getValuableQuotes(quoteValues) {
      return quoteValues.filter(item => (item.weightcode || item.categorycode) && item.price);
    },
    handleCateChange(e) {
      const { section, quoteValues } = e || {};
      // 如果普货的增加了行话，其他类型也需要添加这个行话
      if (section === DEFAULT_QUOTE_SECTION) {
        Object.entries(QUOTE_SECTION).forEach(([key]) => {
          if (key !== DEFAULT_QUOTE_SECTION) {
            const ref = this.$refs[`QuotationEditTable_${key}`];
            if (ref) {
              ref[0].handleExtendLine(quoteValues);
            }
          }
        });
      }
    },
    handleChange(e) {
      // console.log('handleChange: ', e, this.$refs);
      const { quoteValues = [], section = 0 } = e || {};
      this.quoteValues[section] = quoteValues || [];
    },
    getQuotationLastData() {
      sendRequest(quoteLast, { quoteType: this.quoteType }).then((res) => {
        if (!res) {
          return;
        }
        const list = (res || []).length ? res : [{ section: 0 }];
        // 螃蟹需要区分不同报价种类
        let lastData = [];
        // eslint-disable-next-line eqeqeq
        if (`${this.quoteType}` === '2') {
          // 普货的报价
          let commonQuoteValues = [];
          const commonValue = list.find(item => item.section === DEFAULT_QUOTE_SECTION);
          const commonObj = this.handleQuotes(commonValue || list[0]) || {};
          commonQuoteValues = commonObj.quoteValues || [];
          lastData = Object.keys(QUOTE_SECTION).map((sectionCode) => {
            const value = list.find(item => item.section === sectionCode);
            const { quoteValues } = this.handleQuotes(value);
            let quoteValues_ = quoteValues;
            // 查询上次报价时，如果上次无报价，那么默认为普货或第一个的报价（只保留行话)
            if (!value) {
              quoteValues_ = (commonQuoteValues.map(qItem => ({
                categorycode: qItem.categorycode,
                weightcode: null,
                price: null,
              })));
            }
            return {
              formValues: commonObj.formValues,
              section: sectionCode,
              quoteValues: quoteValues_,
            };
          });
        } else {
          lastData = [this.handleQuotes(list[0])];
        }
        this.lastData = lastData;
        console.log('lastData: ', this.lastData);
      }).catch((e) => {
        console.error(e);
      }).then(() => {
        this.loading = false;
        if (this.lastData && this.lastData.length) {
          this.formValues = {
            ...this.formValues,
            ...this.lastData[0].formValues,
          };
        }
      });
    },
    getMarketLastData() {
      sendRequest(getLastMarketPrice, {
        typeId: this.typeId,
      }).then((res = []) => res).catch((e) => {
        console.error(e.message);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        return [];
      }).then((res) => {
        // console.log('res: ' ,res);
        const list = (res || []).length ? res : [{ section: 0 }];
        if (`${this.quoteType}` === '2') {
          // 普货的报价
          let commonQuoteValues = [];
          const commonValue = list.find(item => item.section === DEFAULT_QUOTE_SECTION);
          // 这里commonValue没有值的话就取第一个是为了拿到单位啥的
          const { quotationContent = '{}' } = commonValue || list[0];
          const { priceInfo = [], specUnit = '' } = JSON.parse(quotationContent) || {};
          commonQuoteValues = priceInfo || [];

          this.lastData = Object.keys(QUOTE_SECTION).map((sectionCode) => {
            // 匹配上次报价类别
            const info = list.find(item => item.section === sectionCode);
            // 查询上次报价时，如果上次无报价，那么默认为普货或第一个的报价（只保留行话)
            let quoteValues_ = [];
            if (!info) {
              quoteValues_ = (commonQuoteValues.map(qItem => ({
                jargonCode: qItem.jargonCode || null,
                specCode: null,
                price: null,
              })));
            } else {
              const qcontent = JSON.parse(info.quotationContent) || {};
              quoteValues_ = qcontent.priceInfo;
            }
            console.log('上次报价详情：', 'section', sectionCode, '价格：', info, priceInfo);
            return {
              formValues: {
                unitCode: specUnit,
              },
              section: sectionCode,
              quoteValues: quoteValues_.map(item => ({
                weightcode: item.specCode,
                categorycode: item.jargonCode,
                price: item.price,
              })),
            };
          });
          // console.log('this.lastData：', this.lastData);
        } else {
          this.lastData = [this.handleQuotes(list[0])];
        }
        console.log('getMarketLastData ：', this.lastData);
      }).catch((e) => {
        console.error(e);
      }).then(() => {
        this.loading = false;
        if (this.lastData && this.lastData.length) {
          this.formValues = {
            ...this.formValues,
            ...this.lastData[0].formValues,
          };
        }
      });
    },
    // 获取上次报价信息
    getLastData() {
      // 报价商报价
      if (this.from === 'quotation') {
        this.getQuotationLastData();
        return;
      }
      this.getMarketLastData();
    },
    handleQuotes(item) {
      const { quotes, section, ...values } = item || {};
      return {
        formValues: {
          ...this.formValues,
          ...values,
        },
        quoteValues: quotes ? JSON.parse(quotes) : [],
        section: section || undefined,
      };
    },
    back() {
      this.$emit('back');
      // this.$router.push({ name: 'Home' });
    },
    isCustom(item) {
      const value = this.formValues[item.dataIndex];
      const currentOptions = this.dictOptions[item.optionKey];
      // console.log('value---', item.title, value === '' || !(currentOptions || []).find(v => v.value === value), value, currentOptions);
      return !(value === null || (currentOptions || []).find(v => v.value === value));
    },
    resetFormValue(dataIndex) {
      this.$set(this.formValues, dataIndex, null);
    },
    /**
     * 生成 keywords 字符串
     * @param {Array} categoryCodes - 品类代码数组
     * @returns {String} - 英文逗号分隔的品类名称字符串
     */
    generateKeywords(categoryCodes) {
      if (!categoryCodes || !categoryCodes.length) {
        return '';
      }
      // 从字典中查找对应的品类名称
      const categoryTexts = categoryCodes.map((code) => {
        // 如果 code 本身就是自定义文本（不在字典中），直接使用
        const category = (this.options.categories || []).find(item => item.value === code);
        return category ? category.text : code;
      }).filter(text => text && text.trim());
      // 去重
      const uniqueTexts = [...new Set(categoryTexts)];
      // 返回英文逗号分隔的字符串
      return uniqueTexts.join(',');
    },
    getDict() {
      // console.log(this.units);
      return sendRequest(quoteDict).then((res = {}) => {
        this.allDicts = res;
      }).catch((e) => {
        console.error(e);
      });
    },
    publish() {
      // 判断上方表单必填项
      const uncompletedFormFields = this.items.filter(item => item.required && !this.formValues[item.dataIndex]);
      if (uncompletedFormFields && uncompletedFormFields.length) {
        this.$dialog.alert({
          message: `请补充${uncompletedFormFields.map(item => `【${item.title}】`).join('、')}缺失的信息后再发布`,
        });
        return false;
      }
      const params = [];
      try {
        Object.entries(this.quoteValues).forEach(([section, value]) => {
          const values = this.handleParams(section, value);
          // eslint-disable-next-line no-unused-expressions
          values && params.push(values);
        });
        console.log('publish: ', params, this.quoteValues);
        this.$emit('publish', params);
      } catch (error) {
        this.$dialog.alert({
          message: error.message,
        });
      }
      // TODO
      return params;
    },
    handleParams(section, value) {
      const valuableQuotes = this.getValuableQuotes(value);
      // 判断报价信息是否完善
      if (!valuableQuotes.length) {
        return false;
      }
      const { requiredFileds = [] } = this.quoteTypeConfig || {};
      const uncompletedQuoteFields = valuableQuotes.map((item, itemIndex) => ({
        ...item,
        itemIndex,
      })).filter((item) => {
        if (requiredFileds.length) {
          return !(requiredFileds.every(k => item[k] || item[k] === 0) || requiredFileds.every(k => !item[k] && item[k] !== 0));
        }
        return false;
      });
      if (uncompletedQuoteFields && uncompletedQuoteFields.length) {
        const errMsg = `请补充${this.sectionMapping[section] || ''}报价中${uncompletedQuoteFields.map(item => `第${item.itemIndex + 1}行`).join('、')}缺失的信息后再发布`;
        throw new Error(errMsg);
      }
      // 判断行话、规格都重复的情况
      const repeat = valuableQuotes.some((item, itemIndex) => valuableQuotes.some((val, valIndex) => (
        val.categorycode === item.categorycode && val.weightcode === item.weightcode && itemIndex !== valIndex
      )));
      if (repeat) {
        const errMsg = `不能发布多条行话和规格都一样的报价，请检查下您的${this.sectionMapping[section] || ''}报价信息，调整后重新发布价格`;
        this.$dialog.alert({
          message: errMsg,
        });
        throw new Error(errMsg);
      }
      // 生成 keywords：从品类代码中提取，为每个档次独立生成
      const categoryCodes = valuableQuotes.map(item => item.categorycode);
      const keywords = this.generateKeywords(categoryCodes);
      return {
        ...this.formValues,
        records: valuableQuotes.map(item => ({ ...item, categoryCode: item.categorycode, weightCode: item.weightcode })),
        quoteType: this.quoteType,
        section: section > 0 ? section : undefined,
        keywords,
        visibility: 'public',
      };
    },
    initOptions() {
      // 处理码表 字典值
      const { priceType = [], ...dicts } = this.allDicts;
      const config = QUOTE_TYPE_MAPPING[this.quoteType] || {};
      const dict = dicts[config.dictCode] || {};
      dict.priceType = priceType;
      this.options = dict;
    },
    initValues() {
      const formValues = {};
      this.items.forEach((val) => {
        formValues[val.dataIndex] = null;
      });
      this.formValues = formValues;
      this.quoteValues = {};
      // this.addLine();
    },
  },
  created() {
    // console.log('组件的声明周期-----', this.quoteType);
    this.initValues();

    // 查询码表
    this.loading = true;
    const pros = [];
    pros.push(this.getDict());
    Promise.all(pros).then((res) => {
      // 处理码表 字典值
      this.initOptions();
    }).catch(() => {
      this.loading = false;
    });
  },
});
</script>
<style scoped>
.QuotationEditComponent {
  /* min-height: 100vh; */
  background-color: #ffffff;
  padding-bottom: 20px;
  text-align: left;
}
.QuotationEditComponent .select-palceholder {
  color: #a7a9af!important;
}
.QuotationEditComponent .border-bottom {
  /* border-bottom: 1px solid #1e67c7; */

}
.basic-select,.basic-textarea,.basic-input {
  width: 100%;
  color: #000000;
  font-size: 18px;
}
.form-item {

}
.form-item-label {
  width: 105px;
  text-align: right;
}
.form-item-label-text.required::before {
  content: '*';
  color: red;
}
.form-item-select,.form-item-textarea,.form-item-input {
  width: 100%;
}
.quotation-item {
  /* background-color: #00f2f2; */
  margin-top: 16px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}
.quotation-item.quotation-section {
  border: 1px solid #1e67c7;
}
.quotation-item.quotation-section table tr:last-child td {
  border-bottom: 0;
}
.quotation-item .quotation-item-title {
  color: #ee0a24;
  text-align: center;
  background-color: #00f2f2;
  border-radius: 8px 8px 0 0;
  font-weight: bold;
}
.QuotationEditComponent .quotation-item >>> .QuotationEditTable .table-quotation {
  border: 0!important;
}
</style>
